import React from "react";
import "./Testimonials.css";

export default function Testimonials() {
  const reviews = [
    {
      name: "Alice",
      photo: "https://randomuser.me/api/portraits/women/44.jpg",
      comment: "This platform helped me land my dream remote job!",
      rating: 5,
    },
    {
      name: "Bob",
      photo: "https://randomuser.me/api/portraits/men/32.jpg",
      comment: "Easy to use and full of opportunities.",
      rating: 4,
    },
    {
      name: "Clara",
      photo: "https://randomuser.me/api/portraits/women/68.jpg",
      comment: "Excellent guidance and job listings!",
      rating: 5,
    },
  ];

  return (
    <section className="testimonials">
      <h2>People's Reviews</h2>
      <div className="reviews-grid">
        {reviews.map((review, index) => (
          <div key={index} className="review-card">
            <img src={review.photo} alt={review.name} className="review-photo" />
            <h4>{review.name}</h4>
            <div className="stars">
              {Array.from({ length: review.rating }).map((_, i) => (
                <span key={i}>⭐</span>
              ))}
            </div>
            <p>{review.comment}</p>
          </div>
        ))}
      </div>
    </section>
  );
}
